// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

mat-sidenav {
  width: 250px;
}

.circle {
  border-radius: 50%;
}

.with-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  max-height: 130px;
}

.no-shadow {
  box-shadow: none !important;
}

::ng-deep .mat-expansion-panel-body {
  padding: 0px !important;
  padding-left: 10px !important;
}

.bottom-to-top {
  border: 0px;
  border-right: 1px;
  border-style: solid;
  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;
}

.ptr-10 {
  padding-right: 10px;
}

.ptt-10 {
  padding-top: 10px;
}

.logo {
  max-height: 8em;
  max-width: 8em;
}

.bottom-img {
  display: block;
  max-height: 15em;
  max-width: 15em;
}

.bottom-img-wrapper {
  padding-top: 5em;
  padding-bottom: 5em;
  padding-left: 1em;
  padding-right: 1em;
}

.logo-bkg{
  background-color: #F8F8F8;
  height: 50px;
  text-align: -webkit-center;
  align-items: center;
  align-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/sidemenu/sidemenu.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".container {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\nmat-sidenav {\r\n  width: 250px;\r\n}\r\n\r\n.circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n.with-bg {\r\n  overflow: hidden;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  z-index: -1;\r\n  max-height: 130px;\r\n}\r\n\r\n.no-shadow {\r\n  box-shadow: none !important;\r\n}\r\n\r\n::ng-deep .mat-expansion-panel-body {\r\n  padding: 0px !important;\r\n  padding-left: 10px !important;\r\n}\r\n\r\n.bottom-to-top {\r\n  border: 0px;\r\n  border-right: 1px;\r\n  border-style: solid;\r\n  border-image: linear-gradient(to top, #c1c1c1, rgba(0, 0, 0, 0)) 1 100%;\r\n}\r\n\r\n.ptr-10 {\r\n  padding-right: 10px;\r\n}\r\n\r\n.ptt-10 {\r\n  padding-top: 10px;\r\n}\r\n\r\n.logo {\r\n  max-height: 8em;\r\n  max-width: 8em;\r\n}\r\n\r\n.bottom-img {\r\n  display: block;\r\n  max-height: 15em;\r\n  max-width: 15em;\r\n}\r\n\r\n.bottom-img-wrapper {\r\n  padding-top: 5em;\r\n  padding-bottom: 5em;\r\n  padding-left: 1em;\r\n  padding-right: 1em;\r\n}\r\n\r\n.logo-bkg{\r\n  background-color: #F8F8F8;\r\n  height: 50px;\r\n  text-align: -webkit-center;\r\n  align-items: center;\r\n  align-content: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
